<template>
  <v-card v-if="propietario">
    <v-toolbar dark color="blue lighten-3">
      <v-toolbar-title>{{ propietario.nombre }}</v-toolbar-title>
      <!-- <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat>Descargar</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 v-for="(file, f) in files" :key="f">
            <!-- <pre>{{f}} - {{file}}</pre> -->
            <v-layout wrap>
              <v-flex xs5>
                {{ file.description }}
              </v-flex>
              <v-flex xs5>
                {{ file.name }}
              </v-flex>
              <v-flex xs2>
                <!-- <v-btn @click="descarga(file.downloadURL)">Descargar</v-btn> -->
                <a download target="_blank" :href="file.downloadURL">Descargar</a>
                <!-- <a target="_blank" :download="file.name" :href="file.downloadURL">Descargar</a> -->
              </v-flex>
            </v-layout>
            <!-- <div>
              Tipo: {{ file.description }}
              Nombre: {{ file.name }}
              Link: <a target="_blank" :href="file.downloadURL">Descargar</a>
            </div> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <!-- <pre>{{propietario}}</pre> -->
  </v-card>
</template>

<script>
export default {
  name: "DetalleAdjuntosPropietario",
  props: ["propietario"],
  data() {
    return {};
  },

  computed: {
    files() {
      // propietario.files
      let result = []
      if (this.propietario && this.propietario.files) {
        this.propietario.files.forEach(f => {
          f.files.forEach(element => {
            result.push(element)
          });
          // result.push(f.files)
        })
      }
      return result
    },

    descarga(file) {
      document.location = file;
    }
  }
};
</script>
